<template>
  <el-row>
    <el-col>
      <el-form :model="form" ref="form" :rules="rules" @click="$event.stopPropagation()">
        <el-form-item :label="$t('tree.groupName')" label-width="120px" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('tree.tagCode')" label-width="120px" prop="tagCode">
          <el-input v-model="form.tagCode" @input="sanitize($event)">
            <span slot="prefix">#</span>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="save()">{{$t('tree.update')}}</el-button>
          <el-button @click="cancel()">{{$t('tree.cancel')}}</el-button>
        </el-form-item>
      </el-form>
    </el-col>
  </el-row>
</template>

<script>
import axios from "axios";
import {url} from '../service/url'
export default {
  name: "edit-group",
  events: ["updated", "cancelled"],
  props: ["id"],
  data() {
    return {
      loading: true,
      form: {
        name: "",
        tagCode: ""
      },
      rules: {
        name: [
          { required: true, message: this.$t('tree.pleaseInputName'), trigger: "blur" }
        ],
        tagCode: [
          { required: true, message: this.$t('tree.pleaseInputTagCode'), trigger: "change" }
        ]
      }
    };
  },
  created() {
    axios
      .get(`${process.env.VUE_APP_APIURL}/tree/group/${this.id}`)
      .then(res => {
        this.form = {
          name: res.data.name,
          tagCode: res.data.tagCode.replace("#", "")
        };
        this.loading = false;
      })
      .catch(e => {
        this.$message.error(e.response.data.message);
      });
  },
  methods: {
    sanitize(tagCode) {
      this.form.tagCode = tagCode
        .trim()
        .toUpperCase()
        .replace(/[^a-zA-Z 0-9]/g, "");
    },
    cancel() {
      this.$emit("cancelled", null);
    },
    save() {
      this.loading = true;
      this.$refs.form.validate(valid => {
        if (valid) {
          axios
            .put(`${process.env.VUE_APP_APIURL}/tree/group/${this.id}`, this.form)
            .then(() => {
              this.$emit("updated", {
                _id: 1,
                tagCode: `#${this.form.tagCode}`,
                name: this.form.name
              });
              this.loading = false;
            })
            .catch(e => {
              this.$message.error(e.response.data.message);
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>

<style scoped>
.el-input {
  width: 200px;;
}
</style>